import { useMemo } from 'react';

import { useMarketCacheStore } from '@/feature/event-details-sbk/hooks/use-market-cache';
import { useSubscribePublic } from '@/utils/websocket/hooks';

/**
 * Subscribe to 'league:{leagueId}:gamelines' channel and listens for `odds_update` messages
 */
export const useSubscribeLeaguePopularOddsUpdate = (leagueId: string, enabled: boolean = true) => {
    const handleOddsUpdate = useMarketCacheStore(state => state.actions.handleOddsUpdate);
    const params = useMemo(() => ({ leagueId }), [leagueId]);
    useSubscribePublic<'leaguePopularOddsUpdate'>(
        'league:{leagueId}:gamelines',
        params,
        'odds_update',
        handleOddsUpdate,
        enabled
    );
};
